import { useMemo } from "react";

export default function useSearchTable({ data, keyword }) {
  const filteredData = useMemo(() => {
    // If no keyword, return the original unfiltered data
    if (!keyword || String(keyword).trim() === "") {
      return data;
    }

    const lowerKeyword = String(keyword).toLowerCase().trim();

    return data.filter((row) => {
      if (!row || !row.properties) return false;

      // Check if any value inside row.properties includes the keyword
      return Object.values(row.properties).some((val) => {
        if (val === null || val === undefined) return false;
        return String(val).toLowerCase().includes(lowerKeyword);
      });
    });
  }, [data, keyword]);

  return filteredData;
}
